/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from "@angular/core";
import { Navigation } from "app/core/navigation/navigation.types";
import { ApiResponse } from "app/shared/models";
import { HttpClientService } from "app/shared/services/http.client.service";
import { Observable, ReplaySubject, tap } from "rxjs";

@Injectable({ providedIn: "root" })
export class NavigationService {
  private _httpClient = inject(HttpClientService);
  private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  get currentModule(): string {
    const module = localStorage.getItem("cm");

    if (!module || module === "") {
      return "BAS";
    }

    return module;
  }

  set(currentModule: string) {
    localStorage.setItem("cm", currentModule);
  }

  get(moduleId?: string): Observable<any> {
    return this._httpClient.get<ApiResponse<any>>(`/webapp/menus?search=${moduleId ?? "BAS"}`).pipe(
      tap((navigation) => {
        const compact = navigation.data.map((m) => {
          return {
            ...m,
            type: m.children && m.children.length ? "aside" : "basic",
          };
        });

        this._navigation.next({
          default: navigation.data,
          compact,
          horizontal: [],
          futuristic: [],
        });
      })
    );
  }
}
